module.exports = __webpack_public_path__ + "489f051d1bd331c39a687bc1097310df.pdf";